// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

export class DocBates {
  batesPrefix: string; 
  batesNumberStart: number; 
  batesNumberDigits: number;

  static batesStampString(prefix: string, numberStart: number, numberDigits: number, pageCount: number = 1): string {
    let batesStampFormatted: string = "";
    if (numberStart > 0) {
      batesStampFormatted = `${prefix} ${numberStart.toString().padStart(numberDigits, '0')}`;
      if (pageCount > 1) {
        batesStampFormatted += `-${(numberStart + pageCount - 1).toString().padStart(numberDigits, '0')}`;
      }
    }
    return batesStampFormatted;
  }
}
